import { createSelector } from 'reselect'
import { UserState } from '../User'
import { AdsState } from '.'
import { ReduxState } from '../reducers'
import { differenceInDays } from 'date-fns'

export const ADS_INTERSTITIAL_FREQUENCY = 2
export const selectAdsType = createSelector(
  [(state: ReduxState) => state.ads, (state: ReduxState) => state.user],
  (ads: AdsState, user: UserState) => {
    //no ads if user just create an account
    if (user.createdAt) {
      const dd = differenceInDays(new Date(), new Date(user.createdAt * 1000))
      if (dd <= 3) {
        //3day grace before ads
        return 'none'
      }
    }

    if (ads.interstialCounter === 0) {
      return 'interstitial'
      // to much was clearlyreturn 'reward'
    }
    if (ads.interstialCounter % (10 * ADS_INTERSTITIAL_FREQUENCY) === 0) {
      return 'interstitial'
      // to much was clearlyreturn 'reward'
    }
    if (ads.interstialCounter % ADS_INTERSTITIAL_FREQUENCY === 0) {
      // Show reward ad at position 2 in the cycle (after 2 interstitials)
      return 'interstitial'
    }

    return 'none'
  }
)
// AdEventType['LOADED'] |
// AdEventType['ERROR'] |
// AdEventType['OPENED'] |
// AdEventType['CLICKED'] |
// AdEventType['LEFT_APPLICATION'] |
// AdEventType['CLOSED'] |
// RewardedAdEventType['LOADED'] |
// RewardedAdEventType['EARNED_REWARD']interstial
